import axios from 'axios';
import url from './Url';

class financ extends url {
    constructor() { super() }

    getAllOrdersFinanc(Company_ID, dataInicial, dataFinal, countPagination) {

        return axios.get(`${this.url()}/financeiro/${Company_ID}?dataInicial=${dataInicial}&dataFinal=${dataFinal}`)

            .then(response => { return response.data })

            .catch(err => { return err });
    }

    getNF(id) {
        return axios.get(`${this.url()}/find-nf/${id}`)
            .then(response => { return response.data })
            .catch(err => { return err });
    }

}

export default financ;